import { useCallback, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { api } from "@/lib/api";

export const refreshUnread = () => window.dispatchEvent(new Event("vv-unread"));

export function useUnread(enabled) {
  const [counts, setCounts] = useState({ personal: 0, business: 0 });
  const { pathname } = useLocation();
  const load = useCallback(() => {
    if (enabled) api.get("/notifications/unread").then((r) => setCounts(r.data)).catch(() => {});
  }, [enabled]);
  useEffect(() => { load(); }, [load, pathname]);
  useEffect(() => {
    const t = setInterval(load, 60000);
    window.addEventListener("vv-unread", load);
    return () => { clearInterval(t); window.removeEventListener("vv-unread", load); };
  }, [load]);
  return counts;
}
